import type { FaireCategoryEntity } from "../../entity_types/category";

export const cat_women_sweaters: FaireCategoryEntity = {
  token: "cat_women-sweaters",
  type: "category",
  name: "Sweaters",
  level: 3,
  parentToken: "cat_apparel-women",
  href: "/category/women/sweaters",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
